import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          amount: Yup.string()
                                                     .required('Required'),
                                          currency: Yup.string()
                                                       .required('Required'),
                                          paymentMethod: Yup.string(),
                                          customerId: Yup.string()
                                                       .required('Required'),
                                          description: Yup.string(),
                                      });
